module.exports = __webpack_public_path__ + "assets/fbe7001169be7c233e8fa235afef9bd0.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/Bet_5.mp3
 ** module id = 334
 ** module chunks = 0
 **/